import { Component, Input, OnInit } from '@angular/core';
import { RepoSettingsService } from '../../../data/repositories/repo-settings.service';
import { RouterStateService } from '../../../core/routing/router-state.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActivatedRouteSnapshot, Params, Router } from '@angular/router';
import { SubpanelOption } from './sidebar2-subpanel-shared.service';

@UntilDestroy()
@Component({
    selector: 'app-sidebar2-radio-dropdown',
    templateUrl: './sidebar2-radio-dropdown.component.html',
    standalone: false,
})
export class Sidebar2RadioDropdownComponent implements OnInit {
    // @ts-ignore TS2564
    @Input() heading: string;
    @Input() options: SubpanelOption[] = [];
    // @ts-ignore TS2564
    @Input() settingsFlag: string;
    @Input() defaultRoute?: string;
    @Input() defaultQueryParams?: Params;
    // @ts-ignore TS2564
    @Input() modelName: string;

    currentRoute?: ActivatedRouteSnapshot;
    currentRouteUrl: string = '';

    constructor(
        private repoSettings: RepoSettingsService,
        private routerStateService: RouterStateService,
        private router: Router
    ) {}

    ngOnInit() {
        this.routerStateService.routeChanged$.pipe(untilDestroyed(this)).subscribe((route) => {
            this.currentRoute = route;
            this.currentRouteUrl = this.routerStateService.getCurrentUrlRoute();
        });
    }

    radioSelection(item: SubpanelOption) {
        if (!this.currentRoute?.queryParams) return;
        // Need to clone to remove readonly
        let params = JSON.parse(JSON.stringify(this.currentRoute.queryParams));

        // @ts-ignore TS7052
        this.repoSettings[`${this.settingsFlag}Params`] = JSON.stringify(params);

        switch (params.submenu) {
            case 'business-account':
                // @ts-ignore TS7052
                this.repoSettings[`${this.settingsFlag}BusinessAccountChoice`] = item.subRoute;
                break;
            case 'business-setup':
                // @ts-ignore TS7052
                this.repoSettings[`${this.settingsFlag}BusinessSetupChoice`] = item.subRoute;
                break;
            case 'business-api':
                // @ts-ignore TS7052
                this.repoSettings[`${this.settingsFlag}BusinessApiChoice`] = item.subRoute;
                break;
            case 'price-lists':
                // @ts-ignore TS7052
                this.repoSettings[`${this.settingsFlag}PricelistsChoice`] = item.subRoute;
                break;
            case 'recipes':
                // @ts-ignore TS7052
                this.repoSettings[`${this.settingsFlag}RecipesChoice`] = item.subRoute;
                break;
            case 'communications':
                // @ts-ignore TS7052
                this.repoSettings[`${this.settingsFlag}Choice`] = item.subRoute; // When there's only one dropdown we don't need the dropdown heading before 'Choice'
                break;
        }

        // @ts-ignore TS7052
        this.repoSettings[`${this.settingsFlag}RoutePath`] = item.route;

        this.router.navigate([item.route], { queryParams: params, onSameUrlNavigation: 'reload', queryParamsHandling: 'merge' });
    }

    getHeaderLink() {
        const paramsToUse =
            this.defaultQueryParams && this.currentRoute?.queryParams?.submenu !== this.defaultQueryParams.submenu
                ? this.defaultQueryParams
                : this.currentRoute?.queryParams;
        const destParams = JSON.parse(JSON.stringify(paramsToUse)) || {}; // Clone so we don't alter the state params here

        switch (this.defaultQueryParams?.submenu) {
            case 'business-account':
                if (this.repoSettings.NavigationV2MyBusinessBusinessAccountChoice) {
                    destParams.choice = this.repoSettings.NavigationV2MyBusinessBusinessAccountChoice;
                }
                break;
            case 'business-setup':
                if (this.repoSettings.NavigationV2MyBusinessBusinessSetupChoice) {
                    destParams.choice = this.repoSettings.NavigationV2MyBusinessBusinessSetupChoice;
                }
                break;
            case 'business-api':
                if (this.repoSettings.NavigationV2MyBusinessBusinessApiChoice) {
                    destParams.choice = this.repoSettings.NavigationV2MyBusinessBusinessApiChoice;
                }
                break;
            case 'price-lists':
                if (this.repoSettings.NavigationV2CataloguesPricelistsChoice) {
                    destParams.choice = this.repoSettings.NavigationV2CataloguesPricelistsChoice;
                }
                break;
            case 'recipes':
                if (this.repoSettings.NavigationV2CataloguesRecipesChoice) {
                    destParams.choice = this.repoSettings.NavigationV2CataloguesRecipesChoice;
                }
                break;
            case 'communications':
                if (this.repoSettings.NavigationV2CommunicationsChoice) {
                    destParams.choice = this.repoSettings.NavigationV2CommunicationsChoice;
                }
                break;
        }

        const item = destParams.choice ? this.options.find((o) => o.subRoute === destParams.choice) : this.options[0] || this.options[0];
        // Shouldn't occur, but just in case
        if (!item) throw Error('No options provided to sidebar dropdown.');

        const destRoute = item.route;
        if (!destParams.choice) {
            destParams.choice = item.subRoute;
        }

        // If submenu is not specified in the settingsFlagParams, try to extract from the heading
        destParams.submenu = this.defaultQueryParams?.submenu ?? this.heading.toLowerCase().split(' ').join('-');
        destParams.subpanel = 'true';

        // Set the open destination parameter value
        destParams.open = destParams.open && destParams.open === 'true' ? 'false' : 'true';

        // Heading to a different route or submenu under this panel? Make it default to open...
        // But only make it default to open if we are not a dropdown with radio selections in it (cos they will be all different subRoutes)
        // if ((this.settingsFlagVal !== this.state.current.name) || (this.stateParams.submenu !== this.settingsFlagParams.submenu)) {
        if (this.currentRoute?.queryParams?.submenu !== this.defaultQueryParams?.submenu) {
            destParams.open = 'true';
        }

        // Don't stash any settings if we're on a non-replacement route (routeLess panel)
        if (!this.repoSettings.ShowIntegrationsPanel && !this.repoSettings.ShowExplorePanel && !this.repoSettings.ShowMyProfilePanel) {
            // @ts-ignore TS7052
            this.repoSettings[this.settingsFlag + 'RoutePath'] = destRoute;
            // @ts-ignore TS7052
            this.repoSettings[this.settingsFlag + 'Params'] = JSON.stringify(destParams);
        }

        this.router.navigate([destRoute], { queryParams: destParams, queryParamsHandling: 'merge' });
    }

    // @ts-ignore TS7006
    trackByFn(i) {
        return i;
    }
}
